export { default } from './TicketCardWithManager';
